import { Fragment, useState } from "react";
import { connect } from "react-redux";
import { formatterCreateAt, FormatterStatus } from "components/Function";
import { ReactTable } from "components/Table";
import Loading from "components/Loading";
import { getSizePerPageList } from "helper/constant";
import useCallApiUrl from "hook/useCallApiUrl";
import PostForm from "./form";
import useFormSubmit from "./hooks/useFormSubmit";

function AdminPost({ formatterCreateAt }) {
    const [filter, setFilter] = useState({ limit: 50, offset: 0, isAdmin: true });
    const [openAdd, setOpenAdd] = useState(false);
    const [itemEdit, setItemEdit] = useState(null);
    const { data, loading: isLoading, reload } = useCallApiUrl("/api/posts", filter);
    const { handleCreatePost, handleUpdatePost, loading: formLoading } = useFormSubmit();

    const columns = [
        {
            dataField: "_id",
            text: "",
            sort: true,
            formatter: (cell, row, rowIndex) => rowIndex + 1,
        },
        {
            dataField: "title",
            text: "Title",
            sort: true,
        },

        {
            dataField: "status",
            text: "status",
            sort: true,
            formatter: (cell, row, rowIndex) => {
                return <span className={`badge badge-light-${cell === "ACTIVE" ? "success" : "danger"}`}>{cell}</span>;
            },
        },
        {
            dataField: "created_at",
            text: "Created At",
            sort: true,
            formatter: (cell, row) => formatterCreateAt(cell),
        },
        {
            dataField: "-",
            text: "Actions",
            formatter: (cell, row, rowIndex, formatExtraData) => (
                <Fragment>
                    <button
                        onClick={() => {
                            setItemEdit(row);
                        }}
                        className="btn btn-icon btn-bg-light btn-active-color-warning btn-sm me-2"
                        data-tooltip-id="my-tooltip"
                        data-tooltip-content={"Edit"}
                    >
                        <i className="ki-outline ki-notepad-edit fs-2"></i>
                    </button>
                </Fragment>
            ),
        },
    ];

    const groupButton = () => {
        return (
            <div className="d-flex gap-2">
                <button className="btn btn-primary" onClick={() => setOpenAdd(true)}>
                    Create Post
                </button>
            </div>
        );
    };

    const handleTableChange = (type, { page, sizePerPage, searchText }) => {
        if (type === "search") {
            setFilter((prev) => ({ ...prev, offset: 0, search: searchText }));
        } else {
            setFilter((prev) => ({ ...prev, limit: sizePerPage, offset: page - 1 || 0 }));
        }
    };

    const handleCreate = async (data) => {
        const res = await handleCreatePost(data);
        if (res?._id) {
            reload();
            setOpenAdd(false);
        }
    };

    const handleEdit = async (data) => {
        await handleUpdatePost(data);
        reload();
        setItemEdit(null);
    };

    return (
        <Fragment>
            <Loading isLoading={isLoading || formLoading} />
            <div className="card mb-5 mb-xl-10">
                <div className="card-body p-9">
                    <div className="al-variants-table">
                        <ReactTable
                            columns={columns}
                            data={data?.data || []}
                            groupButton={groupButton}
                            handleTableChange={handleTableChange}
                            page={filter.offset + 1}
                            sizePerPage={filter.limit}
                            totalSize={data?.total || 0}
                            alClassName="table-layout-inherit"
                            sizePerPageList={getSizePerPageList(data?.total || 0)}
                        />
                    </div>
                </div>
            </div>
            <PostForm isOpen={openAdd} onClose={() => setOpenAdd(false)} title="Create Post" onSubmit={handleCreate} />
            <PostForm
                isOpen={Boolean(itemEdit)}
                onClose={() => setItemEdit(null)}
                formData={itemEdit}
                title="Edit Post"
                onSubmit={handleEdit}
            />
        </Fragment>
    );
}

const mapStateToProps = (state) => ({});
const mapDispatchToProps = {
    formatterCreateAt,
    FormatterStatus,
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminPost);
